// /////////Pre-Made Worksheet Actions//////////////////////

import * as studentWorksheetTypes from "Store/students/studentsWorksheets/constants";

export const handleUpdateStudentWorksheetProblemFlagStatus = (
  payload: UpdateStudentWorksheetProblemFlagStatusPayload
): studentWorksheetTypes.IHandleUpdateStudentWorksheetProblemFlagStatus => ({
  type: studentWorksheetTypes.HANDLE_UPDATE_STUDENT_WORKSHEET_PROBLEM_FLAG_STATUS,
  payload
});

export const setStudentWorksheetProblemFlag = (
  payload: UpdateStudentWorksheetProblemFlagStatusPayload
): studentWorksheetTypes.ISetStudentWorksheetProblemFlag => ({
  type: studentWorksheetTypes.SET_STUDENT_WORKSHEET_PROBLEM_FLAG,
  payload
});

/* REFACTORED */

export const handleRescheduleWorksheets = (
  payload: WorksheetReschedulePayload[],
  source = "calendar" as "calendar" | "list"
): studentWorksheetTypes.IRescheduleWorksheets => ({
  type: studentWorksheetTypes.HANDLE_RESCHEDULE_WORKSHEETS,
  payload,
  source
});

export const handleFetchStudentWorksheets =
  (): studentWorksheetTypes.IHandleFetchStudentWorksheets => ({
    type: studentWorksheetTypes.HANDLE_FETCH_STUDENT_WORKSHEETS
  });

export const handleAssignWorksheetsToStudent = (
  payload: NewWorksheet,
  source: Source = "list"
): studentWorksheetTypes.IHandleAssignStudentWorksheets => ({
  type: studentWorksheetTypes.HANDLE_ASSIGN_STUDENT_WORKSHEETS,
  payload,
  source
});

export const handleUnassignStudentWorksheets = (
  payload: string[]
): studentWorksheetTypes.IHandleUnassignStudentWorksheets => ({
  type: studentWorksheetTypes.HANDLE_UNASSIGN_STUDENT_WORKSHEETS,
  payload
});

export const handleExcuseStudentWorksheetLateness = (
  payload: WorksheetExcuseLatenessPayload[]
): studentWorksheetTypes.IHandleExcuseStudentWorksheetLateness => ({
  type: studentWorksheetTypes.HANDLE_EXCUSE_STUDENT_WORKSHEET_LATENESS,
  payload
});

export const handleMarkAllWorksheetFlagsReviewed = (
  payload: string[],
  single: boolean = false
): studentWorksheetTypes.IHandleMarkAllWorksheetFlagsReviewed => ({
  type: studentWorksheetTypes.HANDLE_MARK_ALL_WORKSHEET_FLAGS_REVIEWED,
  payload,
  single
});

export const handleResetStudentWorksheets = (
  payload: string[]
): studentWorksheetTypes.IHandleResetStudentWorksheets => ({
  type: studentWorksheetTypes.HANDLE_RESET_STUDENT_WORKSHEETS,
  payload
});

export const submitBulkWorksheetAnswers = (
  payload: WorksheetBulkAnswersPayload
): studentWorksheetTypes.IHandleSubmitBulkWorksheetAnswers => ({
  type: studentWorksheetTypes.HANDLE_SUBMIT_BULK_WORKSHEET_ANSWERS,
  payload
});

export const handleFetchStudentCalendarWorksheets =
  (): studentWorksheetTypes.IHandleFetchStudentCalendarWorksheets => ({
    type: studentWorksheetTypes.HANDLE_FETCH_STUDENT_CALENDAR_WORKSHEETS
  });

export const setStudentWorksheets = (
  payload: Worksheet[]
): studentWorksheetTypes.ISetStudentWorksheets => ({
  type: studentWorksheetTypes.SET_STUDENT_WORKSHEETS,
  payload
});

export const setActiveWorksheet = (
  payload: Worksheet
): studentWorksheetTypes.ISetActiveWorksheet => ({
  type: studentWorksheetTypes.SET_ACTIVE_WORKSHEET,
  payload
});

export const handleStartStudentWorksheet =
  (): studentWorksheetTypes.IHandleStartStudentWorksheet => ({
    type: studentWorksheetTypes.HANDLE_START_STUDENT_WORKSHEET
  });

/**
 * @params: payload: category_ids
 * */
export const handleFetchStudentWorksheetsByCategories = (
  payload: string[]
): studentWorksheetTypes.IHandleFetchStudentWorksheetsByCategories => ({
  type: studentWorksheetTypes.HANDLE_FETCH_STUDENT_WORKSHEETS_BY_CATEGORIES,
  payload
});
